import { gql } from '@apollo/client'

export const POWER_BI_REPORTS_QUERY = gql`
  query POWER_BI_REPORTS_QUERY($filter: PowerBIReportsFilterInput!, $order: OrderInput, $pagination: PaginationInput) {
    powerBIReports(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        createdAt
        updatedAt
        workspaceId
        datasetId
        name
        webUrl
        embedUrl
        standard
        customName
        availableTo {
          availableToUserOrPositionIds
        }
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`

export const POWER_BI_DATASET_REFRESHED_AT_QUERY = gql`
  query POWER_BI_DATASET_REFRESHED_AT_QUERY {
    powerBIDatasetRefreshedAt {
      data {
        time
        status
      }
    }
  }
`

export const POWER_BI_WORKSPACES_QUERY = gql`
  query POWER_BI_WORKSPACES_QUERY($order: OrderInput, $pagination: PaginationInput) {
    powerBIWorkspaces(order: $order, pagination: $pagination) {
      data {
        id
        createdAt
        updatedAt
        companyId
        isReadOnly
        isOnDedicatedCapacity
        name
        standard
      }
    }
  }
`

export const POWER_BI_CHECK_EXPORT_QUERY = gql`
  query POWER_BI_CHECK_EXPORT_QUERY($input: PowerBICheckExportToFileStatusInput!) {
    powerBICheckExportToFileStatus(input: $input) {
      data {
        exportId
        status
      }
    }
  }
`

export const POWER_BI_STANDARD_REPORTS_QUERY = gql`
  query POWER_BI_STANDARD_REPORTS_QUERY($order: OrderInput, $pagination: PaginationInput) {
    powerBIStandardReports(order: $order, pagination: $pagination) {
      data {
        id
        createdAt
        updatedAt
        workspaceId
        name
      }
      pagination {
        pageSkip
        pageTake
        totalCount
      }
    }
  }
`
